import cellGenerator from "./columnUtils";

const foreign_worker_group_action_view_columns = () => [
  {
    id: "profile-name",
    Header: "Profile Name",
    accessor: "ForeignWorkerFormData.new_profile_fw_profile_name",
    minWidth: 300,
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Foreign Worker Name",
    accessor: "ForeignWorkerFormData.new_profile_fw_first",
    minWidth: 300,
    Cell: ({ row: { original } }) => {
      const formData = original.ForeignWorkerFormData;
      const firstName = formData.new_profile_fw_first;
      const lastName = formData.new_profile_fw_last;
      const bothNames = firstName + " " + lastName;
      return bothNames;
    },
  },
  {
    Header: "Alien Registration Number",
    accessor: "ForeignWorkerFormData.new_profile_fw_alien_reg_number",
    minWidth: 300,
    Cell: (props) => cellGenerator(props),
  },
];

export default foreign_worker_group_action_view_columns;
